module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "أين-يمضي"
    }
  }, [_c('h1', [_vm._v("1"), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أين يمضي")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أين باقي الوقت؟")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("مَن الذي يسألُ؟")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("إنَّه الوقتُ")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("على الأرضِ يقفُ متردِّدًا.. لماذا؟")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ارتقَى إلى السماءِ")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لماذا؟")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("مَن الذي أزعجَه؟")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لقد شربَ كأسًا بينَنا")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أين الوقتُ؟")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("يجلسُ على الغصنِ الأخضرِ")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ما الذي ينتظرُ؟")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("العصافيرُ رحلت مِن الأوراقِ الصفراءِ")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أمسكَت بالظلِّ الباقي مِن الأمسِ")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("وراحَت تسعى")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("تبحثُ عن وقتٍ جديد")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أين مضَى الوقتُ؟")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أخذَته الفراشةُ الملوَّنةُ")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("إلى أين؟")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("احتضنَت منه دقائقَ وبعضَ الثَّواني")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لقد رأتِ الحُلمَ الذي كان")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("تراكمَت فوقَه أجندةٌ أخرى")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("بلا قيدٍ.. بلا أملٍ على تلك الصفحةِ الأخرى")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ذلك الكتابُ الدَّفترُ القديمُ")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("الذي يحتضنُ الذكرى التي كانت")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ذَيَّلَتِ الهامشَ بالوقتِ")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("رحلَتِ الفراشاتُ")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("تبحثُ عن وقتٍ جديدٍ")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أين الوقتُ؟")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("يسألُ ويجيبُ")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("فقد أعطَى الكثيرَ")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ومنحَ الكثيرَ مِن الوقتِ")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("انصرفَت عنه رائحةُ الصبرِ")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("تعرَّجَت داخلَه الثَّواني التي كانت")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("اعتصرَ الوقتُ نفسَه في ذلك الكأسِ")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("وضعَ سجلَّه على الطاولةِ الأخرى")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("كانَ الوقتُ أُنسًا")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("كانَ الوقتُ أمسِ")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("وهنا هو ذاكَ الوقتُ")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("يحملُ الكثيرَ")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("الجدولَ والعبيرَ")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("العصفورَ والأملَ")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("فهل الأرضُ هي غيرُ الأرضِ؟")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("واقفًا عليها")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("كانَ له ذكرى")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("رائحةٌ طيِّبةٌ زكيَّة")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ترجَّلَ اليومَ عنه ذلك الأُنسُ")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("والوقتُ غيرُ الوقتِ")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أحمد كريم عز الدين.. سوريا")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4eaaea38","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch006.vue
// module id = 75
// module chunks = 0